var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPaid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 65,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#093F68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.796 64.918H1.38c-.762 0-1.38-.62-1.38-1.384V1.384C0 .62.618 0 1.38 0h47.416c.763 0 1.38.62 1.38 1.385v62.149a1.378 1.378 0 01-1.38 1.385zm-46.035-2.77h44.655V2.77H2.76v59.379z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.382 58.053H8.463a1.38 1.38 0 01-1.145-.623 1.389 1.389 0 01-.125-1.288l14.453-35.464a1.38 1.38 0 012.553 0l14.467 35.464c.169.426.117.908-.138 1.288a1.38 1.38 0 01-1.146.623zm-26.862-2.77h24.847L22.943 24.818 10.52 55.283z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.558 30.659H15.463c-.762 0-1.38-.62-1.38-1.385V8.614c0-.765.618-1.385 1.38-1.385h25.095c.763 0 1.38.62 1.38 1.384v20.661c0 .765-.617 1.385-1.38 1.385zm-23.66-2.77h22.28V10H16.844l.055 17.89z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaid);
export default __webpack_public_path__ + "static/media/icon-paid.690d7aee87a8762b36509fe74be85f99.svg";
export { ForwardRef as ReactComponent };